import React from 'react';
import TopicRollup from 'components/dashboard/rollups/topic/TopicRollup';
import withLoading from 'components/dashboard/rollups/topic/withLoading';
import {
  fetchProfileUsageByTriggerRuleId,
  idsFromStats,
  topicRollupData,
} from 'components/dashboard/rollups/topic/common';
import ExecDashboardSource from 'sources/ExecDashboardSource';
import DirectReportsSource from 'sources/coaching/DirectReportsSource';
import {shouldUpdate} from 'components/StatsPage2.utils';

/**
 * Renders the topic metrics for a manager's dashboard. Includes all teams the manager manages.
 */
class ManagerTopicRollup extends React.PureComponent {
  render() {
    return <TopicRollup {...this.props} />;
  }
}

const promiseProducer = async props => {
  const {startDate, endDate, managerId} = props;
  // StatsPage2 fetches direct reports, but we have no way of hooking in to be sure they're ready.
  const teams = await DirectReportsSource.directReports(managerId);
  const teamIds = teams.map(team => team.id).toJS();
  const metrics = await ExecDashboardSource.getTopicMetrics({
    teams: teamIds,
    startDate,
    endDate,
  });
  const idsOfTeamsHavingMetrics = idsFromStats(metrics).toJS();
  const triggerRules = await ExecDashboardSource.getDashboardTriggers(teamIds);

  return Promise.all([
    Promise.resolve(triggerRules),
    ExecDashboardSource.getConversations({
      teams: idsOfTeamsHavingMetrics,
      startDate,
      endDate,
    }),
    Promise.resolve(teams),
    Promise.resolve(metrics),
    fetchProfileUsageByTriggerRuleId(triggerRules.keySeq()),
  ]);
};

export default withLoading({
  WrappedComponent: ManagerTopicRollup,
  promiseProducer,
  finalStateProducer: ([
    triggerIdToName,
    conversations,
    teams,
    metrics,
    profileUsageByTriggerRuleId,
  ]) => ({
    conversations,
    loading: false,
    loadingError: false,
    profileUsageByTriggerRuleId,
    summaryStats: topicRollupData(triggerIdToName, conversations, metrics),
    teams,
    triggerIdToName,
  }),
  shouldReload: (prevProps, props) => shouldUpdate(prevProps, props, false, true, false),
});
